import { TIPO_INSPECAO } from "@/constants/TIPO_INSPECAO";
import { IAnaliseLaboratorial } from "@/interfaces/IAnaliseLaboratorial";
import { Checkbox, Col, DatePicker, Form, Input, Radio, Row } from "antd";
import dayjs from "dayjs";

export function FormDadosRequisicaoAnaliseLaboratorial({
  requisicao,
}: {
  requisicao: IAnaliseLaboratorial | undefined;
}) {
  const tipoInspecao = requisicao?.estabelecimento
    ? TIPO_INSPECAO[requisicao.estabelecimento.tipoInspecao]
    : "SISE";

  return (
    <Form layout="vertical">
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Estabelecimento">
            <Input
              disabled
              value={`${requisicao?.estabelecimento.numeroInspecao} - ${tipoInspecao} - ${requisicao?.estabelecimento.nome}`}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Data Coleta">
            <DatePicker
              format={"DD/MM/YYYY HH:mm"}
              showTime
              disabled
              style={{ width: "100%" }}
              value={
                requisicao?.dataColeta
                  ? dayjs(requisicao.dataColeta)
                  : undefined
              }
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Etapa">
            <Input disabled value={requisicao?.etapaColeta} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item valuePropName="checked">
            <Checkbox disabled checked={requisicao?.fiscal}>
              Análise Fiscal
            </Checkbox>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Natureza Analise">
            <Radio.Group disabled value={requisicao?.natureza}>
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={24} md={24}>
                  <Radio value="MICROBIOLOGICA">MICROBIOLOGIA</Radio>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Radio value="FISICOQUIMICO">FÍSICO QUÍMICA</Radio>
                </Col>
              </Row>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Condições Amostra">
            <Radio.Group disabled value={requisicao?.condicaoAmostra}>
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Radio value="CONGELADO">CONGELADO SÓLIDO</Radio>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Radio value="CRISTAIS">CRISTAIS DE GELO</Radio>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Radio value="RESFRIADO">RESFRIADO</Radio>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Radio value="AMBIENTE">AMBIENTE</Radio>
                </Col>
              </Row>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Programação">
            <Input
              disabled
              value={
                requisicao?.programacao
                  ? `${dayjs(requisicao?.programacao.dataProgramada).format("DD/MM/YYYY")} - ${requisicao?.programacao.produto?.produto?.nome} - ${requisicao?.programacao.produto?.numeroRotulo}`
                  : undefined
              }
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Produto">
            <Input
              disabled
              value={
                requisicao?.produto
                  ? `${requisicao?.produto?.produto?.nome} - ${requisicao?.produto?.numeroRotulo}`
                  : undefined
              }
            />
          </Form.Item>
        </Col>

        <Col
          xs={24}
          sm={12}
          md={8}
          style={{ display: "flex", alignItems: "end" }}
        >
          <Form.Item valuePropName="checked">
            <Checkbox disabled checked={requisicao?.agua}>
              Água
            </Checkbox>
          </Form.Item>
        </Col>

        {requisicao?.justificativa && (
          <Col xs={24}>
            <Form.Item label="Justificativa">
              <Input.TextArea disabled value={requisicao?.justificativa} />
            </Form.Item>
          </Col>
        )}

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Informações Adicionais">
            <Input disabled value={requisicao?.infAdicional} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Marca">
            <Input disabled value={requisicao?.marca?.nome} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Data Fabricação">
            <DatePicker
              format={"DD/MM/YYYY"}
              disabled
              style={{ width: "100%" }}
              value={
                requisicao?.dataFabricacao
                  ? dayjs(requisicao.dataFabricacao)
                  : undefined
              }
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Data Validade">
            <DatePicker
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              disabled
              value={
                requisicao?.dataValidade
                  ? dayjs(requisicao.dataValidade)
                  : undefined
              }
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Lote">
            <Input disabled value={requisicao?.lote} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Tamanho da Partida">
            <Input disabled value={requisicao?.tamanhoPartida} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Lacre">
            <Input disabled value={requisicao?.lacre} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Lacre Contra Prova Empresa">
            <Input disabled value={requisicao?.lacreCProvaEmp} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Lacre Contra Prova SISE">
            <Input disabled value={requisicao?.lacreCProvaSise} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Data Remessa">
            <DatePicker
              format={"DD/MM/YYYY"}
              disabled
              style={{ width: "100%" }}
              value={
                requisicao?.dataRemessa
                  ? dayjs(requisicao.dataRemessa)
                  : undefined
              }
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={8}>
          <Form.Item label="Temperatura da Amostra na Coleta">
            <Input disabled suffix="°C" value={requisicao?.temperaturaColeta} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Observação">
            <Input.TextArea disabled value={requisicao?.observacaoColeta} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
